export default function AboutSection() {
  return (
    <section id="about" className="py-24 md:py-36 bg-[#0f0f0f] text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Label */}
        <div className="inline-flex items-center gap-2 mb-8">
          <span className="text-xs uppercase tracking-[0.3em] text-white/40 font-medium">
            / About Us /
          </span>
        </div>

        {/* Main heading */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-start mb-20">
          <div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight tracking-tight">
              A team of experts
              <br />
              <span className="text-white/40">building the future</span>
              <br />
              of iOS
            </h2>
          </div>
          <div className="flex flex-col justify-center">
            <p className="text-white/60 text-base md:text-lg leading-relaxed mb-6">
              MAHHERC was founded with a singular vision: to develop modern
              applications that genuinely improve the lives of iOS users around
              the world. Our products are not just apps — they are tools
              engineered with precision, care, and a deep understanding of
              what users truly need.
            </p>
            <p className="text-white/40 text-sm md:text-base leading-relaxed">
              From protecting your digital privacy to optimizing your device
              performance, every product we release is designed to be
              indispensable. We combine cutting-edge technology with
              thoughtful UX to deliver software that simply works.
            </p>
          </div>
        </div>

        {/* Image + text row */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-20 items-center">
          <div className="relative">
            <div className="rounded-2xl overflow-hidden aspect-video lg:aspect-square">
              <img
                src="https://public.readdy.ai/ai/img_res/9a2f9e557c1b42a52957b796ed95c881.jpg"
                alt="MAHHERC team workspace"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-4 -right-4 w-24 h-24 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center">
              <i className="ri-apple-line text-white/30 text-4xl w-10 h-10 flex items-center justify-center" />
            </div>
          </div>

          <div>
            <div className="text-8xl font-extrabold text-white/5 leading-none mb-4 select-none">
              01
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-4 leading-snug">
              Our Engineering Philosophy
            </h3>
            <p className="text-white/50 text-sm md:text-base leading-relaxed mb-8">
              We believe great software starts with empathy for the user. Every
              feature, every interaction, every pixel is deliberate. We obsess
              over performance so you never have to think about it. Security is
              not an afterthought — it is the foundation upon which every
              MAHHERC product is built.
            </p>
            <div className="flex flex-wrap gap-3">
              {["iOS Native", "Privacy-Focused", "Performance-Driven", "User-Centric"].map(
                (tag) => (
                  <span
                    key={tag}
                    className="border border-white/20 rounded-full px-4 py-1.5 text-xs text-white/60 uppercase tracking-widest"
                  >
                    {tag}
                  </span>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
